var map = {
	"./cake.webp": 2372,
	"./correct-ico.webp": 2373,
	"./crown-blue.webp": 2374,
	"./crown.webp": 2375,
	"./pocket.webp": 2376,
	"./present.webp": 2377,
	"./relegation.webp": 2378,
	"./t-deposit.webp": 2379,
	"./t-turnover.webp": 2380,
	"./vip-1.webp": 2381,
	"./vip-2.webp": 2382,
	"./vip-3.webp": 2383,
	"./vip-4.webp": 2384,
	"./vip-5.webp": 2385,
	"./vip-badge.webp": 2386,
	"./vip-bg.webp": 2387,
	"./vip-bonus-bg.webp": 2388,
	"./vip1.webp": 2389,
	"./vip2.webp": 2390,
	"./vip3.webp": 2391,
	"./vip4.webp": 2392,
	"./vip5.webp": 2393,
	"./vip6.webp": 2394
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 395;